/**
 * Card "Added to quote" panel.
 *
 * The product page gets its inline confirmation from an inline script in
 * snippets/buy-buttons.liquid. Product CARDS (homepage, collections, search)
 * add through the same <product-form> but had no feedback of their own — the
 * button kept saying "Add to quote" and only the drawer moved, so a shopper
 * who closed the drawer had no idea the add had landed.
 *
 * This file is deliberately top-level (no IIFE): it needs `subscribe` and
 * `PUB_SUB_EVENTS` from the globals pubsub.js/constants.js publish, and an
 * IIFE here would repeat the CartPerformance scoping bug. Loaded from
 * layout/theme.liquid after global.js so those globals already exist.
 */
document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  const drawer = document.querySelector('cart-drawer');

  // The same product can appear on two cards of one page (Bestsellers AND
  // Deals on the homepage), so matching on variant id alone would flip both.
  // Remember the form that was actually submitted instead.
  let lastSubmittedForm = null;

  document.addEventListener(
    'submit',
    (event) => {
      const productForm = event.target.closest && event.target.closest('product-form');
      if (!productForm) return;
      const panel = panelFor(productForm);
      if (!panel) return;
      lastSubmittedForm = productForm;
      // The panel is this card's feedback, so stop the drawer covering it.
      if (drawer) drawer.dataset.suppressAutoOpen = 'true';
    },
    true
  );

  function panelFor(productForm) {
    const wrapper = productForm.closest('.quick-add');
    return wrapper ? wrapper.querySelector('[data-quote-added-card]') : null;
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.source !== 'product-form') return;
    const productForm = lastSubmittedForm;
    lastSubmittedForm = null;
    if (!productForm) return;

    const panel = panelFor(productForm);
    if (!panel) return;

    const formEl = productForm.querySelector('form');
    const qty = parseInt(formEl && formEl.elements.quantity && formEl.elements.quantity.value, 10);
    const meta = panel.querySelector('[data-quote-added-meta]');
    if (meta) {
      meta.textContent = Number.isFinite(qty)
        ? qty.toLocaleString() + ' units on your quote list.'
        : 'On your quote list.';
    }

    productForm.hidden = true;
    panel.hidden = false;
  });

  document.addEventListener('click', (event) => {
    const more = event.target.closest && event.target.closest('[data-quote-add-more]');
    if (!more) return;
    const panel = more.closest('[data-quote-added-card]');
    if (!panel) return;
    const wrapper = panel.closest('.quick-add');
    const productForm = wrapper && wrapper.querySelector('product-form');
    panel.hidden = true;
    if (productForm) {
      productForm.hidden = false;
      const submit = productForm.querySelector('[type="submit"]');
      if (submit) submit.focus();
    }
  });
});
